import {
    ELECTRIC_CONSUMPTION_ALL,
    ELECTRIC_CONSUMPTION_GET,
    ELECTRIC_CONSUMPTION_PUT,
    ELECTRIC_CONSUMPTION_DEL,
    ELECTRIC_CONSUMPTION_POST,
  } from "../../actions/types";
  
  const initialState = {
    electricConsumption: null,
    isLoading: false,
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case ELECTRIC_CONSUMPTION_ALL:
        return {
          arr: [...action.payload],
          isLoading: true,
        };
      case ELECTRIC_CONSUMPTION_GET:
        return {
          ...action.payload,
          isLoading: true,
        };
      case ELECTRIC_CONSUMPTION_POST:
        return action.payload;
      case ELECTRIC_CONSUMPTION_PUT:
        return action.payload;
      case ELECTRIC_CONSUMPTION_DEL:
        return { isLoading: true };
      default:
        return state;
    }
  }
  